// Module dependencie
import errorLog from 'app/common/redux/actions/errorLog';
import store from 'app/common/redux/store/singleton';

if (window) {
  window.onunhandledrejection = function(err) {
    let error;
    if (typeof err === 'string') {
      error = {
        message: err,
      };
    } else if (typeof err === 'object') {
      error = err.reason;
    }

    if (error && store.instance) {
      store.instance.dispatch(errorLog(error));
    }
  };
}

(function() {
  let local;
  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof window !== 'undefined' && window.document) {
    local = window;
  } else {
    local = self;
  }

  if (typeof local.Promise.prototype.finally !== 'function') {
    local.Promise.prototype.finally = function finallyPolyfill(callback) {
      const constructor = this.constructor;

      return this.then(
        (value) => constructor.resolve(callback()).then(() => value),
        (reason) =>
          constructor.resolve(callback()).then(() => {
            throw reason;
          }),
      );
    };
  }

  // Alias "finally" as "fin" so that ES3 parsers (IE8) doesn't blow up with "reversed keyword".
  Promise.prototype.fin = Promise.prototype.finally;
})();
